import { render, staticRenderFns } from "./SurgicalCases.vue?vue&type=template&id=addb74e2&"
import script from "./SurgicalCases.vue?vue&type=script&lang=js&"
export * from "./SurgicalCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports